import { useEffect, useState } from "react"

export interface CompareElementProps {
	source: Blob | string | null
	altText: string
}

export const CompareElement = (props: CompareElementProps) => {
	const { source, altText } = props

	const [sourceUrl, setSourceUrl] = useState<string | undefined>(undefined)

	useEffect(() => {
		if (!source) {
			return
		}

		if (typeof source === "string") {
			setSourceUrl(source)
			return
		}

		const blob = source
		const u = URL.createObjectURL(blob)
		setSourceUrl(u)

		return () => URL.revokeObjectURL(u)
	}, [source])

	return (
		<img
			src={sourceUrl}
			alt={altText}
			className="block size-full object-cover"
			crossOrigin="anonymous"
		/>
	)
}
